export default "__VITE_ASSET__Bu8ZUA3i__"